{
  "DeleteReminder": "Erinnerung löschen",
  "DismissAlert": "Verwerfen",
  "DismissAllReminders": "Alle Erinnerungen verwerfen",
  "DismissReminder": "Erinnerung verwerfen",
  "EditReminder": "Erinnerung bearbeiten",
  "RemindMe15Min": "Erinnere mich in 15 Minuten",
  "RemindMe5Min": "Erinnere mich in 5 Minuten",
  "RemindMe60Min": "Erinnere mich in einer Stunde",
  "RemindMeTomorrow": "Erinnere mich morgen",
  "Reminder": "Erinnerung",
  "Reminders": "Erinnerungen",
  "Snooze": "Erinnern"
}
